import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

class LangSelect {
  openFlag = false;

  constructor() {
    this.LangSelect();
  }

  LangSelect() {
    const langContainer = document.querySelector('.nav__langContainer');
    langContainer.addEventListener('click', function () {
      this.nextElementSibling.classList.toggle('isShow');
      this.lastElementChild.classList.toggle('rotate');
    });
  }
}
export default LangSelect;
